import React from 'react';
import AppBar from 'material-ui/AppBar';
import { translate } from 'react-i18next';
import Sidebar from 'react-sidebar';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';
import {Menu, MenuItem} from 'material-ui/Menu';
import Store from 'material-ui/svg-icons/action/store';
import ShoppingCart from 'material-ui/svg-icons/action/shopping-cart';
import { NavLink, Redirect } from 'react-router-dom';
import './Layout.css';
import UserMenu from './UserMenu';
import Receipt from 'material-ui/svg-icons/action/receipt';
import Storage from 'material-ui/svg-icons/device/storage';
import Tag from 'material-ui/svg-icons/av/note';
import Portfolio from 'material-ui/svg-icons/action/view-carousel';
import Dashboard from 'material-ui/svg-icons/action/dashboard';
import Divider from 'material-ui/Divider';
import AccountBalance from 'material-ui/svg-icons/action/account-balance';
import LocalOffer from 'material-ui/svg-icons/maps/local-offer';
import muiThemeable from 'material-ui/styles/muiThemeable';

const mql = window.matchMedia('(min-width: 1200px)');

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = { user: null,
      sidebarOpen: false,
      mql: mql,
      sidebarDocked: true,
      zIndex: 3};
  }
  componentWillMount = () => {
    mql.addListener(this.mediaQueryChanged);
    this.setState({mql: mql, sidebarDocked: mql.matches});
  }
  componentWillUnmount = () => {
    this.state.mql.removeListener(this.mediaQueryChanged);
  }
  mediaQueryChanged = () => {
    this.setState({sidebarDocked: this.state.mql.matches});
  }
  toggleSidebar = () => {
    this.setState({sidebarOpen: !this.state.sidebarOpen});
  }

  render() {
    const {t} = this.props;

    //Redirect after login to remove login window
    if (this.props.location.pathname === '/login') {
      return (<Redirect to={'/'} />
      );
    }


    const zIndex = (!this.state.mql.matches) ? 4 : 0;
    const sideBarStyle = {
      root: {
        right: 'auto',
        bottom: 'auto'
      },
      sidebar: {
        top: 64,
        position: 'fixed',
        zIndex: (zIndex+1),
        backgroundColor: 'white'
      },
      content: {
        overflowY: 'auto'
      },
      overlay: {
        zIndex: zIndex
      }
    };
    const activeStyle = {color: this.props.muiTheme.palette.primary1Color};

    const adminLinks = this.props.user.admin ? (
      <div>
        <Divider />
        <MenuItem
          containerElement=
            {<NavLink
              to="/admin/shops"
              activeStyle={activeStyle}
            />}
          primaryText={t('shopkeepers')}
          leftIcon={<Store />}
          onTouchTap={this.toggleSidebar}
        />
        <MenuItem
          containerElement=
            {<NavLink
              to="/admin/standtags"
              activeStyle={activeStyle}
            />}
          primaryText={t('standTags')}
          leftIcon={<Tag />}
          onTouchTap={this.toggleSidebar}
        />
        <MenuItem
          containerElement=
            {<NavLink
              to="/admin/portfolio"
              activeStyle={activeStyle}
            />}
          primaryText={t('portfolio')}
          leftIcon={<Portfolio />}
          onTouchTap={this.toggleSidebar}
        />
        <MenuItem
          containerElement=
            {<NavLink
              to="/admin/dashboard"
              activeStyle={activeStyle}
            />}
          primaryText={t('dashboard.dashboard')}
          leftIcon={<Dashboard />}
          onTouchTap={this.toggleSidebar}
        />
      </div>
    ) : (null);
    const sidebarContent = (
      <Menu>
        <MenuItem
          containerElement=
            {<NavLink
              to="/dashboard"
              activeStyle={activeStyle}
            />}
          primaryText={t('dashboard.dashboard')}
          leftIcon={<Dashboard />}
          onTouchTap={this.toggleSidebar}
        />
        <MenuItem
          containerElement=
            {<NavLink
              to="/stands"
              activeStyle={activeStyle}
            />}
          primaryText={t('stand.stands')}
          leftIcon={<Store />}
          onTouchTap={this.toggleSidebar}
        />
        <MenuItem
          containerElement=
            {<NavLink
              to="/products"
              activeStyle={activeStyle}
            />}
          primaryText={t('product.products')}
          leftIcon={<ShoppingCart />}
          onTouchTap={this.toggleSidebar}
        />
        <MenuItem
          containerElement=
            {<NavLink
              to="/offers"
              activeStyle={activeStyle}
            />}
          primaryText={t('offer.offers')}
          leftIcon={<LocalOffer />}
          onTouchTap={this.toggleSidebar}
        />
        <MenuItem
          containerElement=
            {<NavLink
              to="/sales"
              activeStyle={activeStyle}
            />}
          primaryText={t('sale.sales')}
          leftIcon={<Receipt />}
          onTouchTap={this.toggleSidebar}
        />
        <MenuItem
          containerElement=
            {<NavLink
              to="/inventory"
              activeStyle={activeStyle}
            />}
          primaryText={t('inventory.inventory')}
          leftIcon={<Storage />}
          onTouchTap={this.toggleSidebar}
        />
        <MenuItem
          containerElement=
            {<NavLink
              to="/settlements"
              activeStyle={activeStyle}
            />}
          primaryText={t('settlement.settlements')}
          leftIcon={<AccountBalance />}
          onTouchTap={this.toggleSidebar}
        />
        {adminLinks}
      </Menu>);

    return (
      <div>
        <AppBar title={this.props.user.shopName}
          iconElementRight={<UserMenu />}
          showMenuIconButton={!this.state.mql.matches}
          onLeftIconButtonTouchTap={this.toggleSidebar}
          style={{position: 'fixed', top:0}}
          className='appBar'
        />
        <Sidebar
          children={<div />}
          sidebar={sidebarContent}
          onSetOpen={this.toggleSidebar}
          open={this.state.sidebarOpen}
          docked={this.state.sidebarDocked}
          styles={sideBarStyle}
          rootClassName='sideBar'
        />
      </div>
    );
  }
}

const enhance = compose(muiThemeable(), translate(), firebase, user);

export default enhance(Layout);



// WEBPACK FOOTER //
// ./src/Navigation/Layout.js